import React from 'react'
import { InView } from 'react-intersection-observer'
import { WithNavigateOnInView } from '../../../../@types/props-types'
import { ScreenName } from '../../../../services/domain/wizardScreens'
import { useFormState } from '../wizard/useFormState'

export const defaultPageIntersectionOptions = {
  rootMargin: '-10% 0% -50% 0%',
  threshold: 0,
  delay: 0,
  initialInView: false,
}

// infinite loop bug in prettier
// prettier-ignore
const withNavigateOnInView =
  <T extends WithNavigateOnInView>(Component: React.FC<T>) =>
    ({ ...props }: T) => {
      const { setScrolled } = useFormState();
      return (
        <InView
          {...props.intersectionOptions ?? defaultPageIntersectionOptions}
          onChange={(inView) => {
            inView && props.onNavigate(props.screen);
            inView && props.screen?.name && setScrolled(props.screen.name as ScreenName);
          }}
        >
          <Component {...props} />
        </InView>
      );
    }

export default withNavigateOnInView
